// Utility function to create page URLs
export function createPageUrl(pageName) {
  // Convert page name to kebab-case URL
  const url = pageName
    .replace(/([A-Z])/g, '-$1')
    .toLowerCase()
    .replace(/^-/, '');
  return `/${url}`;
}

export * from "./menuCategories";
export * from "./recipeIngredients";
export * from "./inventoryPurchasing";

